import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=f78156cc&scoped=true&"
import script from "./UpdatePassword.vue?vue&type=script&lang=js&"
export * from "./UpdatePassword.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=f78156cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78156cc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VIcon,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f78156cc')) {
      api.createRecord('f78156cc', component.options)
    } else {
      api.reload('f78156cc', component.options)
    }
    module.hot.accept("./UpdatePassword.vue?vue&type=template&id=f78156cc&scoped=true&", function () {
      api.rerender('f78156cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/auth/UpdatePassword.vue"
export default component.exports